import { defineMessages } from 'react-intl'

const scope = `procurify.expense.featureSet.ExpenseView`

export default defineMessages({
  expenseNotFoundTitle: {
    id: `${scope}.expenseNotFoundTitle`,
    defaultMessage: 'Expense report not found',
  },
  deleteConfirmHeader: {
    id: `${scope}.deleteConfirmHeader`,
    defaultMessage: 'Delete expense report',
  },
  deleteConfirmMessage: {
    id: `${scope}.deleteConfirmMessage`,
    defaultMessage: 'Are you sure you want to delete this expense report?',
  },
  deleteConfirmButton: {
    id: `${scope}.deleteConfirmButton`,
    defaultMessage: 'Delete expense report',
  },
  deleteConfirmCancelButton: {
    id: `${scope}.deleteConfirmCancelButton`,
    defaultMessage: 'Cancel',
  },
  duplicateOverrideConfirmHeader: {
    id: `${scope}.duplicateOverrideConfirmHeader`,
    defaultMessage: 'Confirmation',
  },
  duplicateOverrideConfirmMessage: {
    id: `${scope}.duplicateOverrideConfirmMessage`,
    defaultMessage:
      'This action will override the previous expense report draft.',
  },
  duplicateOverrideConfirmButton: {
    id: `${scope}.duplicateOverrideConfirmButton`,
    defaultMessage: 'Confirm',
  },
  duplicateOverrideConfirmCancelButton: {
    id: `${scope}.duplicateOverrideConfirmCancelButton`,
    defaultMessage: 'Cancel',
  },
  overBudgetConfirmHeader: {
    id: `${scope}.overBudgetConfirmHeader`,
    defaultMessage: 'Over budget',
  },
  overBudgetConfirmMessage: {
    id: `${scope}.overBudgetConfirmMessage`,
    defaultMessage:
      'There is insufficient budget to approve this expense report, do you want to approve anyway?',
  },
  overBudgetConfirmButton: {
    id: `${scope}.overBudgetConfirmButton`,
    defaultMessage: 'Confirm',
  },
  overBudgetConfirmCancelButton: {
    id: `${scope}.overBudgetConfirmCancelButton`,
    defaultMessage: 'Cancel',
  },
  deleteToolbarButton: {
    id: `${scope}.deleteToolbarButton`,
    defaultMessage: 'Delete expense report',
  },
  duplicateToolbarButton: {
    id: `${scope}.duplicateToolbarButton`,
    defaultMessage: 'Duplicate expense report',
  },
  commentsToolbarButton: {
    id: `${scope}.commentsToolbarButton`,
    defaultMessage: 'Comments',
  },
  commentsCountAriaLabel: {
    id: `${scope}.commentsCountAriaLabel`,
    defaultMessage: '{count, plural, one {# comment} other {# comments}}',
  },
  generatePdfToolbarButton: {
    id: `${scope}.generatePdfToolbarButton`,
    defaultMessage: 'Generate PDF',
  },
  spendTrackerToolbarButton: {
    id: `${scope}.spendTrackerToolbarButton`,
    defaultMessage: 'Spend tracker',
  },
  budgetsToolbarButton: {
    id: `${scope}.budgetsToolbarButton`,
    defaultMessage: 'Budgets',
  },
  hideBudgetTrackerButtonLabel: {
    id: `${scope}.hideBudgetTrackerButtonLabel`,
    defaultMessage: 'Hide budgets',
  },
  hideSpendTrackerButtonLabel: {
    id: `${scope}.hideSpendTrackerButtonLabel`,
    defaultMessage: 'Hide spend tracker',
  },
  deleteActionButton: {
    id: `${scope}.deleteActionButton`,
    defaultMessage: 'Delete',
  },
  editActionButton: {
    id: `${scope}.editActionButton`,
    defaultMessage: 'Edit',
  },
  reviseActionButton: {
    id: `${scope}.reviseActionButton`,
    defaultMessage: 'Revise',
  },
  approveButton: {
    id: `${scope}.approveButton`,
    defaultMessage: 'Approve',
  },
  denyButton: {
    id: `${scope}.denyButton`,
    defaultMessage: 'Deny',
  },
  nextApproverPlaceholder: {
    id: `${scope}.nextApproverPlaceholder`,
    defaultMessage: 'Select next approver',
  },
  auditLogHeading: {
    id: `${scope}.auditLogHeading`,
    defaultMessage: 'Audit log',
  },
  detailsTabLabel: {
    id: `${scope}.detailsTabLabel`,
    defaultMessage: 'Details',
  },
  auditLogTabLabel: {
    id: `${scope}.auditLogTabLabel`,
    defaultMessage: 'Audit log',
  },
  reportHeaderTitle: {
    id: `${scope}.reportHeaderTitle`,
    defaultMessage: 'Expense report #{id}',
  },
  pendingFinalApprovalStatusText: {
    id: `${scope}.pendingFinalApprovalStatusText`,
    defaultMessage: 'Pending final approval',
  },
  nextApproverLabel: {
    id: `${scope}.nextApproverLabel`,
    defaultMessage: 'Next approver',
  },
})
